<template>
    <div :class="{'d-flex align-items-center flex-row-reverse': !vertical}">
        <div class="p-1 text-center">
            <img
                @click="changeLocale('en')"
                src="../assets/images/usa.png"
                class="locale-item"
                :class="{'active': locale === 'en', 'small': vertical}"
            />
        </div>

        <div class="p-1 text-center">
            <img
                @click="changeLocale('lt')"
                src="../assets/images/⁬lithuania.png"
                class="locale-item"
                :class="{'active': locale === 'lt', 'small': vertical}"
            />
        </div>
    </div>
</template>

<script>
export default {
  props: {
    vertical: Boolean
  },

  methods: {
    changeLocale (locale) {
      localStorage.setItem('locale', locale)
      location.reload()
    }
  },

  computed: {
    locale () {
      return localStorage.getItem('locale')
    }
  }
}
</script>

<style scoped lang="scss">
    .locale-item {
        width: 24px;
        cursor: pointer;
        opacity: .6;
    }

    .locale-item:hover {
        opacity: 1;
    }

    .locale-item.small {
        width: 18px;
        cursor: pointer;
    }

    .locale-item.small.active {
        width: 24px;
        opacity: 1;
    }

    .locale-item.active {
        width: 32px;
        opacity: 1;
    }
</style>
